<style lang="scss" scoped>
.el-button {
  width: 60px;
  margin-left: 10px;
}
.table {
  background: #fff;
  height: 500px;
}
.blue {
  color: #173bcf;
}
/deep/ {
  .el-pagination button:disabled,
  .el-pager li,
  .el-pagination .btn-prev,
  .el-pagination .btn-next {
    background: transparent;
  }
}
/deep/ .el-table th {
  background: #fff;
}
.downloadbtn {
  cursor: pointer;
}
</style>

<template>
  <div>
    <div>
      <el-date-picker
        v-model="value"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        format="dd/MM/yyyy"
        :picker-options="option"
        @change="changeDate"
      ></el-date-picker>
      <el-button size="mini" type="primary">查询</el-button>
    </div>
    <div class="clearfix mt20 mb20">
      <div class="fl">
        渠道名称:
        <span class="blue">{{name}}</span>
      </div>
      <down-load :tdata="downloadStr" filename=".channeldetail">
        <span href class="fr blue">
          <i class="iconfont iconxiazai1"></i>下载表格
        </span>
      </down-load>
    </div>
    <div class="table">
      <el-table ref="table" :data="tableData" style="width: 100%">
        <el-table-column label="日期">
          <template slot-scope="scope">
            <div>{{momentutc(scope.row.date,'YYYY-MM-DD')}}</div>
          </template>
        </el-table-column>
        <el-table-column prop="scanCount" label="扫码总数"></el-table-column>
        <el-table-column prop="subscribe" label="新粉丝"></el-table-column>
        <el-table-column prop="subscribed" label="老粉丝"></el-table-column>
        <el-table-column prop="unsubscribe" label="取消关注"></el-table-column>
        <el-table-column label="明细">
          <template slot-scope="scope">
            <router-link
              class="blue"
              :to="{path: 'detail',query: {id: qrCodeId,date:scope.row.date}}"
            >粉丝明细</router-link>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="mt40 alignc">
      <el-pagination
        class="pager"
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page="page"
        :total="total"
        @current-change="changePage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import DownLoad from '@/components/download';
import moment from 'moment';
export default {
  components: {
    DownLoad,
  },
  computed: {},
  props: ['id'],
  data() {
    const start = new Date();
    return {
      name: '',
      value: [start.getTime() - 3600 * 1000 * 24 * 30, start],
      page: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      qrCodeId: '',
      option: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      downloadStr: '',
    };
  },

  async mounted() {
    await this.getData();
    this.getAllData();
  },
  methods: {
    download() {},

    async getAllData() {
      let res = await this.$http.get(
        `/api/${this.id}/download/channel/qrcode/${this.qrCodeId}`,
        {
          params: {
            page: 1,
            size: 10000000,
            begin: this.moment(this.value[0]) || null,
            end: this.moment(this.value[1]) || null,
          },
          responseType: 'blob',
        },
      );

      if (res) {
        this.downloadStr = res;
      }
    },

    async changePage(val) {
      this.page = val;
      await this.getData();
    },
    async changeDate() {
      await this.getData();
      this.getAllData();
    },
    async getData() {
      this.qrCodeId = this.$route.query.id;
      let res = await this.$http.get(
        `/api/${this.id}/analyze/channel/qrcode/${this.qrCodeId}`,
        {
          params: {
            page: this.page,
            size: this.pageSize,
            begin: this.moment(this.value[0]) || null,
            end: this.moment(this.value[1]) || null,
          },
        },
      );

      this.name = res.name;
      this.tableData = res.days.list;
      this.total = res.days.totalSize;
    },
  },
};
</script>
